window.jQuery = window.jQuery || require('jquery');
require('./lib/jquery.cycle2.all');
require('./lib/featherlight');

var project = require('../../settings');
var utils = require('./modules/utils');
var stories = require('./modules/story-section');
var nav = require('./modules/primary-nav');
var Cookies = require('js-cookie');


/* Event Handlers */
(function ($) {

    // Automatically equalize height on specified elements
    $(window).load(function () {
        utils.equalHeight('.equal');
        // utils.equalHeight('.featured_events_hp__wrap', '.featured_events_hp__container');
        // utils.equalHeight('.featured_events_hp__title', '.featured_events_hp__container');
        utils.equalHeight('.hp_equal', '.hp_bottom__left_column');

        $(window).trigger('resize').trigger('scroll');

        $('.contactBar .contactBar__control').on('click', function () {
            $('.contactBar').toggleClass('closed')
        })

        setInterval(function () {
            jQuery(window).trigger('resize').trigger('scroll');
        }, 1000);

    });


    stories.init($);

    $('.single-accordion .accordion-header').on('click', function () {
        var $column = $(this).parent();
        $column.toggleClass('open');
        $column.find('.accordion-inner').slideToggle({
            duration: 250,
            progress: function () {
                $(window).trigger('resize');
            }
        });
    });


    nav.init($);
    $('.js-menu-dropdown').click(function () {
        $('.toggle-section-nav').click();
    });


    $('a:not([data-featherlight])').each(function () {
        var a = new RegExp('/' + window.location.host + '/');
        if (!a.test(this.href) && this.href.indexOf('mailto:') === -1 && !this.href.indexOf('javascript') === 1 ) {
            $(this).click(function (event) {
                event.preventDefault();
                event.stopPropagation();
                window.open(this.href, '_blank');
            });
        }
    });


    $("#js-multisearch").click(function (e) {
        e.preventDefault();
        var $phrase = $('#js-news-search--text').val();

        var $source = $('#js-news-search--dropdown').val();

        var startDate = new Date($('#js-news-search--date-start').val());
        var startDay = startDate.getDate();
        var startMonth = startDate.getMonth();
        var startYear = startDate.getFullYear();


        var endDate = new Date($('#js-news-search--date-end').val());
        var endDay = endDate.getDate();
        var endMonth = endDate.getMonth();
        var endYear = endDate.getFullYear();


        var queryCategory = $("#js-news-search--dropdown").children("option:selected").attr("data-category-id");

        var querySiteID = $("#js-news-search--dropdown").children("option:selected").attr("data-blog-id");

        if (Number.isNaN(endYear)) {
            var $endDateParameter = -1;
        } else {
            var $endDateParameter = [endYear, endMonth, endDay].join('/');
        }

        if (Number.isNaN(startYear)) {
            var $startDateParameter = -1;
        } else {
            var $startDateParameter = [startYear, startMonth, startDay].join('/');
        }


        //alert($phrase + [startYear, startMonth, startDay].join('/') + [endYear, endMonth, endDay].join('/') + $source + queryCategory + querySiteID);

        window.location.href = window.location.protocol + "//" + window.location.host + "/search/page/1?s=" + $phrase + "&start_date=" + $startDateParameter + "&end_date=" + $endDateParameter + "&in_site=" + querySiteID + "&category=" + queryCategory;

    });

    /**
     * Logic to handle Accordion Permalinks
     * This function is for handling in-site clicks
     */

    $(function () {

        $('a[href*=#]:not([href=#])').click(function () {
            console.log("Link Clicked. Determining Accordion Logic");
            if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                if (target.length) {
                    $('html,body').unbind().animate({scrollTop: $(target).offset().top - 150}, 'slow');
                    return false;
                }
            }
        });
    });


    /**
     * Logic to handle Accordion Permalinks
     * This function is for handling out of site navigation directly to the page
     */

    if (window.location.hash) { //Check if there's a hash, and that we're on the Resource Page
        var rawHash = window.location.hash; //Put the hash in a variable
        var hashClickableElement = rawHash + " .accordion-header";

        setTimeout(function () {
            var target = $(rawHash);
            console.log(target);
            if (target.length) {
                $('html,body').unbind().animate({scrollTop: $(target).offset().top - 150}, 'slow');
                $(hashClickableElement).click();
                console.log("Clicked item:" + hashClickableElement);
                return false;
            }
        }, 500);

    } else {
        /**
         * Don't currently need to do anything, but maybe later?
         */
    }


    var scroll_offset = -50;
    var scroll_speed = 1000;
    ScrollToHash = function (hash, child, offset, speed) {
        offset = offset || 0;
        speed = speed || 800;

        if (hash.indexOf('/') >= 0) {
            hash = hash.split('/', 1)[0];
        }

        hash = encodeURIComponent(hash.replace('#', ''));

        var element = jQuery('[data-scroll="' + hash + '"]');

        if (child && jQuery(element).find(child).length > 0) {
            element = jQuery(element).find(child);
        }

        if (jQuery(element).length > 0) {
            if (!element.hasClass('recent-scroll')) {
                element.addClass('scroll-target').addClass('recent-scroll');
            }

            jQuery('html, body').animate({
                scrollTop: (
                    element.offset().top - (200 + offset)
                )
            }, {
                complete: function () {
                    setTimeout(function () {
                        element.removeClass('scroll-target');
                    }, 500);

                    setTimeout(function () {
                        element.removeClass('recent-scroll');
                    }, 5000);
                }
            }, speed);
            return true;
        }

        return false;
    };

    //updated scroll to hash code
    if (location.hash) {
        $(window).on("load", function () {
            setTimeout(function () {
                ScrollToHash(location.hash, null, scroll_offset, scroll_speed);

            }, 300);

        });
    }

    $(window).on('hashchange', function (e) {
        if (location.hash) {
            if (!ScrollToHash(location.hash, null, scroll_offset, scroll_speed)) {
                e.preventDefault();
            }
        }
    });

    $('.trending_popup .trending_popup__exit').on('click', function () {
        $(this).parents().removeClass('active');
        Cookies.set('trending-popup', 'closed');
    });

    $(window).on('load', function () {
        if (Cookies.get('trending-popup') != 'closed') {
            setTimeout(function () {
                $('.trending_popup').addClass('active');
            }, 5000)
        }

        $(document).mouseleave(function () {
            console.log("Exit Trigger");
            if (Cookies.get('trending-popup') != 'closed') {
                $('.trending_popup').addClass('active');
            }
        });
    });

})(window.jQuery);